export enum StoreType {
    Store,
    Dealer
}
